import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-block3" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "online" }
const _hoisted_4 = { class: "online_r" }

import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const toPath = (path:string,type: string = 'router') => {
    if(type != 'router'){
        const url = router.resolve(path);
        console.log('--------',url.href);  // 输出为#/test-url
        // 打开新窗口
        window.open(url.href);
    }else{
        router.push(path)
    }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[29] || (_cache[29] = _createElementVNode("h1", { class: "t2_title" }, [
        _createElementVNode("span", null, [
          _createTextVNode("在线办事"),
          _createElementVNode("br"),
          _createElementVNode("small", null, "Online service")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "online_l" }, [
          _createElementVNode("a", { class: "online_l_more" }, [
            _createTextVNode("查看更多"),
            _createElementVNode("i", { class: "leftAndright" })
          ]),
          _createElementVNode("img", { src: "images/limg.png" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _cache[8] || (_cache[8] = _createElementVNode("img", { src: "images/online_icon1.png" }, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "政务服务大厅", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toPath('/walk-into-zmq')))
              }, [...(_cache[7] || (_cache[7] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[11] || (_cache[11] = _createElementVNode("img", { src: "images/online_icon2.png" }, null, -1)),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "进度查询", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toPath('/other-page/inquire')))
              }, [...(_cache[10] || (_cache[10] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[14] || (_cache[14] = _createElementVNode("img", { src: "images/online_icon3.png" }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "我要咨询", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toPath('/other-page/consult')))
              }, [...(_cache[13] || (_cache[13] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[17] || (_cache[17] = _createElementVNode("img", { src: "images/online_icon6.png" }, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("span", null, "咨询回复", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toPath('/other-page/complainList')))
              }, [...(_cache[16] || (_cache[16] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[20] || (_cache[20] = _createElementVNode("img", { src: "images/online_icon4.png" }, null, -1)),
              _cache[21] || (_cache[21] = _createElementVNode("span", null, "我要投诉", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toPath('/other-page/complain')))
              }, [...(_cache[19] || (_cache[19] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[23] || (_cache[23] = _createElementVNode("img", { src: "images/online_icon5.png" }, null, -1)),
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "环保直通车", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (toPath('/eco-friendly','open')))
              }, [...(_cache[22] || (_cache[22] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _cache[26] || (_cache[26] = _createElementVNode("img", { src: "images/online_icon2.png" }, null, -1)),
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "外贸一件事", -1)),
              _createElementVNode("a", {
                class: "online_r_more",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toPath('/simpleOneThingList','open')))
              }, [...(_cache[25] || (_cache[25] = [
                _createTextVNode("点击进入", -1),
                _createElementVNode("i", { class: "leftAndright" }, null, -1)
              ]))])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})